import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

export const ConfirmAction = ({ trigger, title, description, confirmLabel = "Conferma", onConfirm, testId }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
    <AlertDialogContent className="w-[calc(100vw-1.5rem)] max-w-md rounded-3xl bg-white">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display">{title}</AlertDialogTitle>
        {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
      </AlertDialogHeader>
      <AlertDialogFooter className="gap-2">
        <AlertDialogCancel className="h-11 rounded-full" data-testid={`${testId}-cancel`}>Annulla</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="h-11 rounded-full bg-[#0F2D5E] hover:bg-[#0B2250]" data-testid={`${testId}-confirm`}>{confirmLabel}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
